import React from "react";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import backArrow from "../../assets/at-details/arrow-back.svg";

export const BuildWebbContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10rem auto;
  background-color: var(--mainlight);
`;

export const TwoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  max-width: 900px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FullWidthContainer = styled.div`
  grid-column: span 2;
  max-width: 900px;
  margin-top: 10px;
`;

export const Section = styled.section`
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

export const BuildWebHeading = styled.h2`
  font-size: 20px;
  margin-bottom: 15px;
  font-weight: 500;
`;

export const BuildWebParagraph = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: var(--maindark);
  margin-bottom: 15px;
`;

export const BuildWebHeader = styled.h1`
  font-size: 28px;
  color: var(--maindark);
  font-weight: 500;
  letter-spacing: 1px;
  margin: 2rem 0 1rem 0;

  @media screen and (min-width: 768px) {
    font-size: 30px;
    margin: 2rem 0 1rem 0;
  }

  @media screen and (min-width: 1024px) {
    font-size: 36px;
    margin: 2rem 0 1rem 0;
  }
`;

export const BuildWebbIntroHead = styled.h3`
  font-size: 14px;
  font-weight: 300;
  color: var(--maindark);
  white-space: nowrap;
  letter-spacing: 1.7px;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 18px;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
  }
`;

export const Underline = styled.div`
  width: 100px;
  height: 4px;
  background-color: var(--accent-pink);
  margin: 0 auto 4rem auto;

  @media (min-width: 768px) {
    width: 110px;
  }

  @media (min-width: 1024px) {
    width: 120px;
  }
`;

export const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 10px 0;
`;

export const StyledListItem = styled.li`
  font-size: 16px;
  line-height: 1.5;
  color: #333;
  margin-bottom: 8px;

  strong {
    font-weight: 500;
    color: #000;
  }
`;

// Back arrow button
const bouncyArrow = keyframes`
  0% { transform: translateX(0); }
  40% { transform: translateX(-8px); } 
  60% { transform: translateX(-3px); }
  80% { transform: translateX(-8px); }
  100% { transform: translateX(0); }
`;

const BackArrowButton = styled.button`
  background: none;
  border: none;
  color: var(--maindark);
  cursor: pointer;
  padding: 10px;
  margin: 0;
  display: flex;
  align-items: center;
  align-self: flex-start;

  img {
    width: 28px;
    height: 28px;
    transition: opacity 0.3s ease-in-out;
    opacity: 0.5;
  }

  &:hover img {
    opacity: 0.9;
    animation: ${bouncyArrow} 0.8s ease-in-out;
  }
`;

export const BackArrow: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <BackArrowButton onClick={handleBack}>
      <img src={backArrow} alt="Back arrow" />
    </BackArrowButton>
  );
};
